import { render } from "./gateComponent.vue?vue&type=template&id=0799e023"
import script from "./gateComponent.vue?vue&type=script&lang=js"
export * from "./gateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__